import mixpanel from 'mixpanel-browser'

// Initialize once at module load time so every importer shares the same instance
mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  persistence: 'localStorage',
  // Log each event to the console in dev so you can verify without opening Mixpanel
  debug: import.meta.env.DEV,
})

// Vue plugin — adds $mixpanel to Options API components
export const mixpanelPlugin = {
  install(app) {
    app.config.globalProperties.$mixpanel = mixpanel
  },
}

export default mixpanel
